import { func } from "prop-types";
import { triggerEvent } from "../../js/main/utils";

const initTabs = block => {
    const teamTabs = block.querySelectorAll(".enplusone-team__tabs > .for-desktop > ul > li");
    const tabContent = block.querySelectorAll(".enplusone-team__list-content");

    const phoneTabs = block.querySelector(
        ".enplusone-team__tabs .for-phone .select"
    );

    const teamItems = block.querySelectorAll(".enplusone-team__list-content > ul > li.enplusone-team__list-single");

    const close = block.querySelectorAll('.enplusone-modal > .enplusone-modal__close');

    if (close) {
        close.forEach(function (item) {
            item.addEventListener("click", e => {
                e.stopPropagation();
                document.body.classList.remove("no-scroll");
                item.parentElement.classList.remove('show-modal');
            });
        });
    }

    teamItems.forEach(function (element) {
        element.addEventListener("click", e => {
            console.log('hello')
            document.body.classList.add("no-scroll");
            element.querySelector('.enplusone-modal').classList.add('show-modal');
        });

    });

    if (teamTabs.length && tabContent.length) {
        let prevHeight = tabContent[0].offsetHeight;

        const loopTabs = callback => {
            [...teamTabs].forEach(callback);
        };

        const resetTabs = () => {
            loopTabs((el, i) => {
                const c = tabContent[i];

                el.classList.remove("active");
                c.classList.remove("active");
            });
        };

        const animateTab = (content, height) => {
            if ("animate" in content) {
                content.animate(
                    { height, opacity: [0, 1] },
                    { duration: 300, iterations: 1, easing: "ease-out" }
                );
            }
        };

        const setActiveTab = (tab, content, isAnimate = true) => {
            if (tab.classList.contains("active")) {
                return false;
            }

            resetTabs();

            tab.classList.add("active");

            if (content) {
                content.classList.add("active");

                const elHeight = content.offsetHeight + "px";

                if (isAnimate) {
                    animateTab(content, [prevHeight, elHeight]);
                }

                prevHeight = elHeight;
            }
        };

        loopTabs((tab, index) => {
            const content = tabContent[index];

            tab.addEventListener("click", e => {
                e.preventDefault();
                setActiveTab(tab, content);

                if (phoneTabs) {
                    phoneTabs.selectedValue = index;
                    triggerEvent(phoneTabs, "selectUpdate");
                }
            });
        });

        if (phoneTabs) {
            const tabItems = phoneTabs.querySelectorAll('ul > li');
            phoneTabs.addEventListener("click", () => {
                phoneTabs.classList.toggle('active');
            });

            tabItems.forEach(function (element) {
                element.addEventListener('click', () => {
                    const content = element.textContent;
                    const value = element.getAttribute('data-value');
                    phoneTabs.querySelector('.enplusone-team__tabs-default').textContent = content;
                    element.parentNode.querySelector('.active').classList.remove('active');
                    element.classList.add('active');
                    
                    if (typeof value !== "undefined") {
                        const tab = teamTabs[value];
                        const content = tabContent[value];

                        if (tab && content) {
                            setActiveTab(tab, content);
                        }
                    }
                })
            })

        }
    }
};

const blocks = document.querySelectorAll(".wp-block-supertheme-team");

if (blocks.length) {
    [...blocks].forEach(block => {
        initTabs(block);
    });
}
